<template>
  <OrderQuery breadcrumbTitle="On Service" query="?status=Driving" />
</template>

<script>
import OrderQuery from '@/components/order/OrderQuery.vue';

export default {
  name: 'OrderOnService',
  components: {
    OrderQuery,
  },
};
</script>

<style></style>
